import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'youtubeVideo',
  title: 'YouTube Video',
  type: 'object',
  fields: [
    defineField({
      name: 'url',
      title: 'URL',
      type: 'url',
    }),
    defineField({
      name: 'name',
      title: 'Name / Title',
      type: 'string',
    }),
    defineField({
      name: 'description',
      title: 'Description',
      type: 'text',
      rows: 3,
    }),
    defineField({
      name: 'uploadDate',
      title: 'Upload date',
      type: 'date',
      initialValue: new Date().toISOString().split('T')[0],
    }),
  ],
})